import React from "react";
import { INDUSTRIES } from "@/constants/site";
import * as Icons from "lucide-react";
import { useQuote } from "@/components/QuoteProvider";
import useSeo from "@/hooks/useSeo";
import { breadcrumbSchema } from "@/lib/schema";

export default function IndustriesPage() {
  const { openQuote } = useQuote();
  useSeo({
    title: "Industries We Supply — Aerospace, Defence, Railways, Manufacturing | SSK Enterprises",
    description:
      "SSK Enterprises supplies NDT materials, KLYDE zinc coatings and industrial bearings to aerospace, defence, railways, power generation, oil & gas, casting, forging, boiler and machine-building industries across Telangana and Andhra Pradesh.",
    path: "/industries",
    jsonLd: [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Industries", path: "/industries" }])],
  });
  return (
    <>
      <section className="bg-slate-50 border-b border-slate-200">
        <div className="container-x py-16">
          <div className="overline mb-3">Industries We Supply</div>
          <h1 className="font-display text-4xl md:text-5xl font-black text-[#1E293B]">Trusted across critical industrial sectors</h1>
          <p className="text-slate-600 mt-4 max-w-2xl">SSK Enterprises supports inspection, surface protection and bearing needs across a wide range of industrial sectors in Telangana and Andhra Pradesh.</p>
        </div>
      </section>
      <section className="section">
        <div className="container-x">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {INDUSTRIES.map((ind) => {
              const Ic = Icons[ind.icon] || Icons.Factory;
              return (
                <div key={ind.name} className="tech-card p-6 flex flex-col items-center text-center gap-3" data-testid={`industry-${ind.name.toLowerCase().replace(/\s+/g,"-")}`}>
                  <div className="w-12 h-12 bg-slate-50 border border-slate-200 flex items-center justify-center">
                    <Ic className="w-6 h-6 text-[#0F2747]" />
                  </div>
                  <div className="text-sm font-semibold text-[#1E293B]">{ind.name}</div>
                </div>
              );
            })}
          </div>
          <div className="mt-14 text-center">
            <button onClick={() => openQuote()} className="btn-primary" data-testid="industries-cta">Enquire for your industry</button>
          </div>
        </div>
      </section>
    </>
  );
}
